export function filterCaseInsensitive(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];

    // if search term is surrounded by quotes, search for an exact match
    if (filterValue.length > 2 && filterValue[0] === '"' && filterValue[filterValue.length - 1] === '"') {
      return filterValue.slice(1, -1) === String(rowValue);
    }

    return rowValue !== undefined
      ? String(rowValue).toLowerCase().indexOf(String(filterValue).toLowerCase()) > -1
      : true;
  });
}

export function filterEmptyRow(rows, id) {
  return rows.filter((row) => {
    const rowValue = row.values[id];

    return rowValue.length > 0;
  });
}
